import React from 'react';
import { AwardIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { productBrand, productEdition, totalBonuses, totalVolumes } from '../data/offer';
export function SystemSection() {
  return <section className="border-y border-border bg-surface py-16 sm:py-20" aria-labelledby="system-title" data-id="element-182" data-mp="3bhbu9hm7k3fw">
      <div className="mx-auto max-w-4xl px-4 text-center" data-id="element-183" data-mp="36jk4at54irec">
        <span className="inline-flex items-center gap-2 rounded-full border border-border bg-background px-4 py-1.5 text-sm font-medium text-foreground" data-id="element-184" data-mp="31kyzegexfjjk">
          <AwardIcon className="h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-185" data-mp="2ws5xs1er8rbp" /> The Most Complete Cement & Concrete Technology Professional System
        </span>
        <SectionHeading id="system-title" className="mt-6" data-id="element-186" data-mp="2nulrge21c4u8">
          {productBrand} — <span className="text-primary" data-id="element-187" data-mp="2iuhcisgrzi64">{productEdition}</span>
        </SectionHeading>
        <p className="mt-4 font-medium text-muted" data-id="element-188" data-mp="2dummss8qkymn">
          {totalVolumes} volumes · {totalBonuses} exclusive bonuses
        </p>

        <p className="mx-auto mt-10 flex max-w-3xl items-start gap-3 rounded-xl border border-border bg-background p-6 text-left text-lg font-medium leading-relaxed text-foreground shadow-sm" data-id="element-189" data-mp="13yg4o6e9f33c">
          <CheckIcon className="mt-1 h-6 w-6 shrink-0 text-primary" aria-hidden="true" data-id="element-190" data-mp="u2czsss0wqcp" />
          A complete technical reference to understand cement and concrete from the raw meal to the finished structure:
          how the kiln turns raw materials into clinker, how cement chemistry and SCMs shape performance, how mixes are
          designed, produced, placed and cured, and how concrete is tested, inspected and kept durable.
        </p>
      </div>
    </section>;
}